module.exports = "https://trybtryb-legacy.web.app/img/consultant.16e26a99.svg";